import CartActionTypes from "../../actionTypes/cart"
import { getCart } from "../../reducers"
import { getCartItems, updateCart } from "../../../services/cartHelper"
import { getIsFrance } from "../../../services/locale"

const addDiscountAction = (couponCode) => (dispatch, getState) => {
  if (!couponCode) {
    return
  }

  const { checkout, client, isLoading } = getCart(getState())

  if (isLoading === true) {
    return
  }

  if (!checkout) {
    console.error("A checkout is required")

    return
  }

  dispatch({
    type: CartActionTypes.DISCOUNT_ADDING_ACTION,
  })

  const isBrowser = typeof window !== "undefined"
  let items = []

  if (isBrowser) {
    items = getCartItems()
  }

  const checkoutId = checkout.id
  let codeError = []
  let giftCardError = []
  let isCodeValid = true
  let error = ""
  let discountApplications = []
  const isFrance = getIsFrance()

  return client.checkout
    .addDiscount(checkoutId, couponCode)
    .then((checkout) => {
      if (checkout.userErrors.length > 0) {
        codeError = checkout.userErrors
      }

      return client.checkout.addGiftCards(checkoutId, [couponCode])
    })
    .then((finalCheckout) => {
      if (finalCheckout.userErrors.length > 0) {
        giftCardError = finalCheckout.userErrors
      }

      discountApplications = finalCheckout.discountApplications

      processCartUpdate(dispatch, items, finalCheckout, couponCode)

      if (
        codeError.length === 0 &&
        giftCardError.length > 0 &&
        discountApplications.length === 0
      ) {
        isCodeValid = false
        error = isFrance
          ? "Ce code de réduction n’est pas applicable pour les articles dans votre panier."
          : "This discount code isn’t applicable for the items in your cart."
      }

      if (codeError.length > 0 && giftCardError.length > 0) {
        isCodeValid = false
        error = isFrance ? "Code invalide" : "Code is invalid"
      }

      return { isCodeValid, error }
    })
}

function processCartUpdate(dispatch, items, checkout, couponCode) {
  let cartData = updateCart(items, checkout)

  //create and parse a deep copy of the cartData to avoid mutation
  let newPayload = JSON.parse(JSON.stringify(cartData))

  dispatch({
    type: CartActionTypes.DISCOUNT_ADD_ACTION,
    payload: {
      ...newPayload,
      isAdded: true,
    },
  })

  window.setTimeout(function () {
    dispatch({
      type: CartActionTypes.ADDED_ACTION,
      payload: {
        isAdded: false,
      },
    })
  }, 1000)
}

export { addDiscountAction }
